import { render } from "./PayPeriod.vue?vue&type=template&id=7a6d78ac"
import script from "./PayPeriod.vue?vue&type=script&lang=ts"
export * from "./PayPeriod.vue?vue&type=script&lang=ts"
script.render = render

export default script